module.exports = __webpack_public_path__ + "static/media/line.f30ce0ee.svg";